<template>
  <v-text-field
    ref="inputRef"
    v-bind="$attrs"
    :prefix="currency"
    @blur="$emit('blur', $event)"
  />
</template>

<script>
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'NumericInput',
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    currency: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => {
        return {
          currency: 'USD',
          autoDecimalDigits: true,
          currencyDisplay: 'hidden',
          hideGroupingSeparatorOnFocus: false,
          valueRange: { min: 0 }
        }
      }
    }
  },
  setup(props, { emit }) {
    const { inputRef, setOptions, numberValue } = useCurrencyInput(
      props.options,
      false
    )

    watch(
      () => props.options,
      options => {
        setOptions(options)
      }
    )

    watch(
      () => numberValue.value,
      value => {
        emit('input', value)
      }
    )

    return { inputRef }
  }
}
</script>
